/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreatePhotonBeamQualitiesDto } from './CreatePhotonBeamQualitiesDto';
import {
    CreatePhotonBeamQualitiesDtoFromJSON,
    CreatePhotonBeamQualitiesDtoFromJSONTyped,
    CreatePhotonBeamQualitiesDtoToJSON,
} from './CreatePhotonBeamQualitiesDto';
import type { CreateElectronBeamQualitiesDto } from './CreateElectronBeamQualitiesDto';
import {
    CreateElectronBeamQualitiesDtoFromJSON,
    CreateElectronBeamQualitiesDtoFromJSONTyped,
    CreateElectronBeamQualitiesDtoToJSON,
} from './CreateElectronBeamQualitiesDto';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { NullableOneOfPropertyOfStorageLocation } from './NullableOneOfPropertyOfStorageLocation';
import {
    NullableOneOfPropertyOfStorageLocationFromJSON,
    NullableOneOfPropertyOfStorageLocationFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationToJSON,
} from './NullableOneOfPropertyOfStorageLocation';
import type { OneOfPropertyOfPtw100InternalArea } from './OneOfPropertyOfPtw100InternalArea';
import {
    OneOfPropertyOfPtw100InternalAreaFromJSON,
    OneOfPropertyOfPtw100InternalAreaFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaToJSON,
} from './OneOfPropertyOfPtw100InternalArea';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';

/**
 * 
 * @export
 * @interface CreateLinearAcceleratorDto
 */
export interface CreateLinearAcceleratorDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateLinearAcceleratorDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateLinearAcceleratorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLinearAcceleratorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLinearAcceleratorDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateLinearAcceleratorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateLinearAcceleratorDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof CreateLinearAcceleratorDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof CreateLinearAcceleratorDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {CreateElectronBeamQualitiesDto}
     * @memberof CreateLinearAcceleratorDto
     */
    beamQualitiesElectron?: CreateElectronBeamQualitiesDto;
    /**
     * 
     * @type {CreatePhotonBeamQualitiesDto}
     * @memberof CreateLinearAcceleratorDto
     */
    beamQualitiesPhoton?: CreatePhotonBeamQualitiesDto;
    /**
     * 
     * @type {number}
     * @memberof CreateLinearAcceleratorDto
     */
    sourceAxisDistance: number;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof CreateLinearAcceleratorDto
     */
    parentCoordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {NullableOneOfPropertyOfStorageLocation}
     * @memberof CreateLinearAcceleratorDto
     */
    imageLocation?: NullableOneOfPropertyOfStorageLocation;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {OneOfPropertyOfPtw100InternalArea}
     * @memberof CreateLinearAcceleratorDto
     */
    ptw100AreaName?: OneOfPropertyOfPtw100InternalArea;
    /**
     * 
     * @type {string}
     * @memberof CreateLinearAcceleratorDto
     */
    $type?: CreateLinearAcceleratorDtoTypeEnum;
}


/**
 * @export
 */
export const CreateLinearAcceleratorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateLinearAcceleratorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateLinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateLinearAcceleratorDtoTypeEnum = typeof CreateLinearAcceleratorDtoTypeEnum[keyof typeof CreateLinearAcceleratorDtoTypeEnum];



/**
 * Check if a given object implements the CreateLinearAcceleratorDto interface.
 */
export function instanceOfCreateLinearAcceleratorDto(value?: unknown): value is CreateLinearAcceleratorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateLinearAcceleratorDtoTypeEnum)[0];
}

export function CreateLinearAcceleratorDtoFromJSON(json: any): CreateLinearAcceleratorDto {
    return CreateLinearAcceleratorDtoFromJSONTyped(json, false);
}

export function CreateLinearAcceleratorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLinearAcceleratorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'beamLimitingDeviceType': json['beamLimitingDeviceType'] == null ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': json['beamProduction'] == null ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'beamQualitiesElectron': json['beamQualitiesElectron'] == null ? undefined : CreateElectronBeamQualitiesDtoFromJSON(json['beamQualitiesElectron']),
        'beamQualitiesPhoton': json['beamQualitiesPhoton'] == null ? undefined : CreatePhotonBeamQualitiesDtoFromJSON(json['beamQualitiesPhoton']),
        'sourceAxisDistance': json['sourceAxisDistance'],
        'parentCoordinateSystem': json['parentCoordinateSystem'] == null ? undefined : CoordinateSystemFromJSON(json['parentCoordinateSystem']),
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'imageLocation': json['imageLocation'] == null ? undefined : NullableOneOfPropertyOfStorageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': json['externalRtSystemId'] == null ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': json['externalFileSystemPath'] == null ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': json['ptw100AreaName'] == null ? undefined : OneOfPropertyOfPtw100InternalAreaFromJSON(json['ptw100AreaName']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateLinearAcceleratorDtoToJSON(value?: CreateLinearAcceleratorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isAvailable': value['isAvailable'],
        'isArchived': value['isArchived'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryToJSON(value['subCategory']),
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value['beamLimitingDeviceType']),
        'beamProduction': MedicalSystemBeamProductionToJSON(value['beamProduction']),
        'beamQualitiesElectron': CreateElectronBeamQualitiesDtoToJSON(value['beamQualitiesElectron']),
        'beamQualitiesPhoton': CreatePhotonBeamQualitiesDtoToJSON(value['beamQualitiesPhoton']),
        'sourceAxisDistance': value['sourceAxisDistance'],
        'parentCoordinateSystem': CoordinateSystemToJSON(value['parentCoordinateSystem']),
        'serialNumber': value['serialNumber'],
        'imageLocation': NullableOneOfPropertyOfStorageLocationToJSON(value['imageLocation']),
        'externalRtSystemId': value['externalRtSystemId'],
        'externalFileSystemPath': value['externalFileSystemPath'],
        'ptw100AreaName': OneOfPropertyOfPtw100InternalAreaToJSON(value['ptw100AreaName']),
        '$type': value['$type'],
    });
}

